<template>
  <p
    class="search-result-text"
    tabindex="0"
  >
    {{ setCategoryTitle(category) }} 검색결과
    <span class="col-vari-blue">{{ setNumberCommas(totalCount) }}</span>
  </p>
</template>

<script>
export default {
  name: 'SearchResultCount',
  props: {
    isLoading: {
      type: Boolean
    },
    totalCount: {
      type: Number
    },
    category: {
      type: String
    },
    searchTitle: {
      type: String
    }
  },
  methods: {
    setNumberCommas (data = 0) {
      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    setCategoryTitle (category) {
      switch (category) {
        case 'program' : return '프로그램'
        case 'vod' : return '에피소드'
        case 'moviesvod' : return '영화'
        case 'movieppv' : return '영화 플러스'
        case 'live' : return 'LIVE'
        case 'vodbaseball' : return '프로야구'
        case 'category' : return '카테고리'
      }
    }
  }
}
</script>
